import { createRecipe } from './runtime';

const linkConfig = {"name":"link"}

export const link = /* @__PURE__ */ createRecipe(linkConfig)